"use client";
import React from "react";
import Link from "next/link";
import { RequestDemoCTA } from "@/components/site/Header/cta";
import { useCurrentLocale, useI18n } from "@/locales/client";

const FinalCtaSection = () => {
  const t = useI18n();
  const locale = useCurrentLocale();
  return (
    <div className="relative bg-gray-50 py-16 overflow-hidden">
      <div className="relative z-10 max-w-7xl 3xl:max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 3xl:px-[150px] flex flex-col lg:flex-row lg:justify-between lg:items-center gap-6 lg:gap-0">
        <div>
          <p className="text-orange-500 font-semibold">{t("see-it-in-action")}</p>
          <h2 className="text-3xl font-extrabold text-gray-900">
            {t("want-to-see-how-solyntek-fits-your-facility")}
          </h2>
        </div>
        <div className="flex w-full flex-col items-start gap-4 sm:flex-row sm:items-center sm:w-auto">
          <div className="w-full sm:w-auto [&>a]:flex [&>a]:w-full sm:[&>a]:w-auto">
            <RequestDemoCTA />
          </div>
          <Link
            href={`/${locale}/contact`}
            aria-label={t("contact-us")}
            className="group relative inline-flex h-12 w-full items-center rounded-lg bg-[#FF8B49] p-1 transition-colors duration-200 hover:bg-[#212121] active:bg-[#212121] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF8B49] sm:w-fit xl:h-14 2xl:h-16"
          >
            <span className="flex h-full flex-1 items-center justify-center rounded-md bg-white px-6 text-sm font-bold text-black transition-colors duration-200 whitespace-nowrap group-hover:bg-[#FF8B49] group-active:bg-[#FF8B49] xl:px-7 xl:text-base 2xl:px-8 2xl:text-lg">
              {t("contact-us")}
            </span>
            <span className="grid h-full w-12 xl:w-14 2xl:w-16 place-items-center rounded-md bg-inherit shrink-0" aria-hidden>
              <svg
                viewBox="0 0 24 24"
                className="h-6 w-6 xl:h-7 xl:w-7 2xl:h-8 2xl:w-8 transform transition-transform duration-200 -rotate-45 group-hover:rotate-0 group-active:rotate-0"
                fill="none"
              >
                <path
                  d="M6 12h12M13 7l5 5-5 5"
                  stroke="#fff"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FinalCtaSection;
export { FinalCtaSection as SeeInAction };
